export const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 12;

const DEFAULT_FRONTEND_HOSTS = new Set(['storefront', 'checkout', 'backoffice']);
const RESERVED_STORE_HOSTS = new Set(['api', 'backoffice', 'checkout', 'storefront']);

export function resolveSharedCookieDomain(hostname: string | undefined): string | null {
  if (!hostname) return null;
  const normalized = hostname.toLowerCase();

  if (
    normalized === 'localhost' ||
    normalized === '127.0.0.1' ||
    normalized === '::1'
  ) {
    return null;
  }

  const stageHostMatch = normalized.match(/^([^.]+)\.(dev|prod)\.trafiflow\.com$/);
  if (stageHostMatch && DEFAULT_FRONTEND_HOSTS.has(stageHostMatch[1])) {
    return `.${stageHostMatch[2]}.trafiflow.com`;
  }

  if (stageHostMatch && !RESERVED_STORE_HOSTS.has(stageHostMatch[1])) {
    return `.${stageHostMatch[1]}.${stageHostMatch[2]}.trafiflow.com`;
  }

  const namedFrontendMatch = normalized.match(/^(checkout|backoffice)\.([^.]+)\.(dev|prod)\.trafiflow\.com$/);
  if (namedFrontendMatch && !RESERVED_STORE_HOSTS.has(namedFrontendMatch[2])) {
    return `.${namedFrontendMatch[2]}.${namedFrontendMatch[3]}.trafiflow.com`;
  }

  return null;
}

export function buildCookieString(name: string, value: string | null, hostname?: string): string {
  const domain = resolveSharedCookieDomain(hostname);
  const domainSegment = domain ? `; domain=${domain}` : '';

  if (value === null || value === '') {
    return `${name}=; path=/; max-age=0; SameSite=Lax${domainSegment}`;
  }

  return `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${domainSegment}`;
}
